'use client';

import HeroSection from './HeroSection';
import ContactForm from './ContactForm';
import LocationSection from './LocationSection';
import BusinessHoursSection from './BusinessHoursSection';
import ContactMethodsSection from './ContactMethodsSection';
import EmergencyContactSection from './EmergencyContactSection';
import Footer from '@/app/homepage/components/Footer';

export default function ContactUsInteractive() {
  return (
    <>
      <HeroSection />
      <ContactForm />
      <ContactMethodsSection />
      <LocationSection />
      <BusinessHoursSection />
      <EmergencyContactSection />
      <Footer />
    </>
  );
}